import React from 'react';
import {LinksContainerDPC, YtEmbedDPC} from "../../index";
import { LinksDPC, AllegatoContainerDPC, AllegatoDPC } from "../../index";

export default ({ title, body, id, accordionId, img, tabella, video, links, allegati }) => {
    return (
        <>
            <div className="collapse-header" id={`accordion${accordionId}Heading${id}`}>
                <h2>
                    <a data-toggle="collapse" role="tab" href={`#accordion${accordionId}Panel${id}`}
                        data-target={`#accordion${accordionId}Panel${id}`}
                        aria-controls={`accordion${accordionId}Panel${id}`} aria-expanded="false">
                        {title}
                    </a>
                </h2>
            </div>
            <div role="tabpanel" data-parent={`#accordion${accordionId}`} id={`accordion${accordionId}Panel${id}`}
                aria-labelledby={`accordion${accordionId}Heading${id}`}
                className="collapse">
                <div className="collapse-body">

                    {img ?
                        <>
                            <img
                                src={img.relationships.image?.localFile?.childImageSharp?.fluid?.src}
                                className="img-fluid float-left"
                                alt={img.field_alt} />
                            <div dangerouslySetInnerHTML={{ __html: body ? body : '' }} />
                        </>
                        : <div dangerouslySetInnerHTML={{ __html: body ? body : '' }} />}

                    {tabella &&
                        <div className="table-responsive table table-custom" dangerouslySetInnerHTML={{ __html: tabella }} />}

                    {video &&
                    <div className="gallery-photo-video-embed">
                        <YtEmbedDPC
                            classe = {"px-5"}
                            titoloSezione={video.title}
                            url={video.field_video?.uri}
                            descrizione={video.field_didascalia} />
                    </div>}

                
                {links &&
                <LinksContainerDPC>
                    <LinksDPC links={links}/>
                </LinksContainerDPC>
                }

                {Array.isArray(allegati) && allegati.length > 0 &&
                    <AllegatoContainerDPC titoloSezione={'Allegati'}>
                        {
                            allegati.map(allegato => (
                                <AllegatoDPC
                                    titolo={allegato.field_titolo_esteso}
                                    descrizione={allegato.relationships?.field_allegato?.description}
                                    dimension={allegato.relationships?.field_allegato?.filesize}
                                    slug={allegato.relationships?.field_allegato?.localFile?.publicURL}
                                    extension={allegato.relationships?.field_allegato?.localFile?.extension}
                                />
                            ))
                        }
                    </AllegatoContainerDPC>}
                    </div>
            </div>


        </>
    )
};
